export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8426.48665e50.jpg";